export default __webpack_public_path__ + "images/graphics/find-car.svg";